module.exports = "/assets/data/66139e0a5469aea39cc271a0e2cbaf28-B70.data.json";